import m from "mithril";
import s from "./styles.module.scss";
import IconCheckmark from "@app/icons/dark-checkmark";
import WarningIcon from "@app/icons/warning";

import CloseIcon from "@app/icons/x-close";

import NotifyModel from "@app/models/notify";

const Notifier = {};

Notifier.view = () => {
    const { show, message, closeNotify, warning } = NotifyModel;

    return m("div", { class: [s.notify, show ? s.show : ""].join(" ") }, [
        m(
            "div",
            { class: s.main },
            m("span", {}, [warning ? WarningIcon : IconCheckmark]),
            message,
            m("p", { class: s.main_time }, "Just now")
        ),
        m("span", { class: s.close, onclick: () => closeNotify() }, [
            CloseIcon,
        ]),
    ]);
};

export default Notifier;
